// extracted by css-extract-rspack-plugin
export default {"organisationContactDetails":"CandidateNomination_organisationContactDetails__3gVy2"};